let env = {};

// env.baseURL = 'http://172.24.48.1:8000/api/v1/';
// env.normalURL = 'http://172.24.48.1:8000/';
env.baseURL = 'https://api.sigap-central.it4d.com.br/api/v1/';
env.normalURL = 'https://api.sigap-central.it4d.com.br/';

export default env
